import { PortalDialogProps } from "@app/services/modal.service";
import { CreateAdmin } from "@app/types";
import { useEffect, useRef } from "react";
import Input from "../input";
import Button from "../button";
import Modal from "../modal/modal.component";
import { Form, Formik, FormikContextType } from "formik";
import { FormControl } from "../form-control";
import { createAdminValidationSchema } from "@app/validations";
import { Role } from "@app/constants";

interface CreateAdminProps {
  admin: CreateAdmin;
}

const CreateAdminModal = ({
  portalDialogRef,
  portalData,
}: PortalDialogProps<CreateAdminProps>) => {
  const formRef = useRef<FormikContextType<CreateAdmin>>(null);

  const onSubmit = (values: CreateAdmin) => {
    portalDialogRef.close({ admin: values });
  };

  useEffect(() => {
    if (portalData?.admin && formRef.current) {
      formRef.current.setValues({
        fullName: portalData.admin.fullName,
        username: portalData.admin.username,
        password: portalData.admin.password,
        email: portalData.admin.email,
        role: portalData.admin.role,
      });
    }
  }, [portalData?.admin]);

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[423px] py-7 px-6">
        <div className="text-black font-semibold text-xl">Tạo admin</div>
        <Formik
          innerRef={formRef}
          initialValues={{
            username: "",
            password: "",
            fullName: "",
            email: "",
            role: Role.ADMIN,
          }}
          onSubmit={onSubmit}
          validationSchema={createAdminValidationSchema}
          validateOnChange
          validateOnBlur
        >
          <Form>
            <FormControl name="fullName">
              <Input className="mt-3" placeholder="Họ và tên" />
            </FormControl>
            <FormControl name="username">
              <Input className="mt-3" placeholder="Tên đăng nhập" />
            </FormControl>
            <FormControl name="password">
              <Input className="mt-3" placeholder="Mật khẩu" type="password" />
            </FormControl>
            <FormControl name="email">
              <Input className="mt-3" placeholder="Email" />
            </FormControl>
            <FormControl name="role">
              <Input className="mt-3 hidden" placeholder="Role" />
            </FormControl>
            <div className="mt-11 flex justify-center gap-4">
              <Button
                size="xs"
                label="Hủy"
                theme="secondary"
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
                onClick={portalDialogRef.close}
              />
              <Button
                type="submit"
                size="xs"
                label="Tạo"
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
              />
            </div>
          </Form>
        </Formik>
      </div>
    </Modal>
  );
};

export default CreateAdminModal;
